<template>
  <div id="trs-menu">
    <div class="mobile-nav" v-if="mobileMode && !tabletMode">
      <a href="#" class="btn btn-lg-edit btn-block btn-danger" v-open-app-mobile
         :url-universal-link="linksAppList.FX_UNIVERSAL_LINK_URL"
         :url-app-store="linksAppList.FX_APPSTORE_URL"
         :url-deep-link="linksAppList.FX_DEEP_LINK_URL"
         :url-android-link="linksAppList.FX_OPENAPP_ANDROID_URL">
        {{ $t('trs.front.header.label.fx.trade.app') }}
      </a>
      <a href="#" class="btn btn-lg-edit btn-block btn-primary" v-open-app-mobile
         :url-universal-link="linksAppList.SC_UNIVERSAL_LINK_URL"
         :url-app-store="linksAppList.ST_APPSTORE_URL"
         :url-deep-link="linksAppList.SC_DEEP_LINK_URL"
         :url-android-link="linksAppList.SC_OPENAPP_ANDROID_URL">
        {{ $t('trs.front.header.label.system.trade.app') }}
      </a>
      <a v-if="!isIOS" href="#" class="btn btn-lg-edit btn-block btn-green" v-open-app-mobile
         :url-universal-link="linksAppList.BO_UNIVERSAL_LINK_URL"
         :url-app-store="linksAppList.BO_APPSTORE_URL"
         :url-deep-link="linksAppList.BO_DEEP_LINK_URL"
         :url-android-link="linksAppList.BO_OPENAPP_ANDROID_URL">
        {{ $t('trs.front.header.label.bo.trade.app') }}
      </a>
      <a v-if="isIOS" href="#" class="btn btn-lg-edit btn-block btn-green" v-open-app-mobile
         :url-universal-link="linksAppList.BO_UNIVERSAL_LINK_URL"
         :url-app-store="linksAppList.BO_APPSTORE_URL"
         :url-deep-link="linksAppList.BO_DEEP_LINK_URL"
         :url-android-link="linksAppList.BO_OPENAPP_ANDROID_URL">
        {{ $t('trs.front.header.label.bo.trade.ios') }}
      </a>
      <a v-if="headerInfo && headerInfo.hasCryptAccount && headerInfo.cryptOpenCompleted"
         href="#" class="btn btn-lg-edit btn-block btn-crypto_app" v-open-app-mobile
         :url-universal-link="linksAppList.CRYPT_UNIVERSAL_LINK_URL"
         :url-app-store="linksAppList.CRYPT_APPSTORE_URL"
         :url-deep-link="linksAppList.CRYPT_DEEP_LINK_URL"
         :url-android-link="linksAppList.CRYPT_OPENAPP_ANDROID_URL">
        {{ $t('trs.front.header.label.crypto.trade.app') }}
      </a>
      <a v-if="headerInfo && headerInfo.hasCryptAccount && !headerInfo.cryptOpenCompleted"
         href="#" class="btn btn-lg-edit btn-block btn-crypto_app" @click="handleCryptoRedirect(linksAppList)">
        {{ $t('trs.front.header.label.crypt') }}
      </a>
    </div>

    <div class="mobile-nav" v-if="(!mobileMode && !tabletMode) || tabletMode">
      <a v-if="headerInfo && headerInfo.webtradeExpressUrl" class="btn btn-lg-edit btn-block btn-danger" :href="headerInfo.webtradeExpressUrl">
        {{ $t('trs.front.header.label.fx') }}
      </a>
      <a v-if="headerInfo && headerInfo.socialCtx" :href="headerInfo.socialCtx" class="btn btn-lg-edit btn-block btn-primary">
        {{ $t('trs.front.header.label.social') }}
      </a>
      <a v-if="headerInfo && headerInfo.boCtx" :href="headerInfo.boCtx + '/customer/home'" class="btn btn-lg-edit btn-block btn-green">
        {{ $t('trs.front.header.label.bo') }}
      </a>
      <a v-if="headerInfo && headerInfo.hasCryptAccount"  href="#" class="btn btn-lg-edit btn-block btn-crypto_app" @click="handleCryptoRedirect(linksAppList)">
        {{ $t('trs.front.header.label.crypt') }}
      </a>
    </div>

    <ul>
      <li v-for="item in menuItems"
          :class="{ active: item.active }"
          :key="item.id"
          @click="toggleOffCanvasMenu()"
      >
        <router-link :to="item.link" v-if="item.id !== 'performance'">
          <i :class="item.cssClass"></i>
          <span class="menu-label"> {{ $t(item.text) }}</span>
        </router-link>
        <a :href="item.href" v-if="item.id === 'performance' && ((!mobileMode && !tabletMode) || tabletMode)">
          <i :class="'fa fa-fw ' + item.cssClass"></i>
          <span class="menu-label"> {{ $t(item.text) }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * @author HungNS
 */
import {createNamespacedHelpers} from 'vuex';
import $ from "jquery";
import cryptoRedirectMixin from "@/common/mixins/cryptoRedirect";
const {mapState} = createNamespacedHelpers('leftMenu');
const {mapState: mapHeaderState, mapGetters: mapHeaderGetters} = createNamespacedHelpers('header');

export default {
  mixins : [cryptoRedirectMixin],
  data: function () {
    return {}
  },
  computed: {
    ...mapState({
      menuItems: state => state.menuItems
    }),

    ...mapHeaderState({
      headerInfo: state => state.headerInfo,
    }),

    ...mapHeaderGetters(["linksAppList"]),
  },

  methods: {
      handleCryptoRedirect(linksAppList) {
      this.toggleOffCanvasMenu();
      this.redirectCryptoRegistration(linksAppList);
    },

    toggleOffCanvasMenu() {
      $('#trs-menu, .page').toggleClass('offcanvas');
    }
  }
};
</script>

<style scoped>
.menu-label {
  font-size: 12.2px !important;
}

a {
  text-align: left;
}
</style>

